import './../../components/Theme/Theme.css'
import './../../components/Theme/Style.css'
import './Home.css'
import './Slides.css'
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import StatisticsSlide from '../../components/Slides/StatisticsSlide/StatisticsSlide';
import WeMachineSlide from '../../components/Slides/WeMachine/WeMachineSlide';
import WeMachineSlide2 from '../../components/Slides/WeMachine/WeMachineSlide2';
import OurCommitmentSlide from '../../components/Slides/OurCommitment/OurCommitmentSlide';
import MissionVisionValuesSlide from '../../components/Slides/MissionVisionValues/MissionVisionValuesSlide';
import Customers from '../../components/Slides/Customers/CustomersSlide';
import ThemeContext from '../../contexts/ThemeContext';
import Certifications from '../../components/Slides/Certifications/CertificationsSlide';
import { Icons } from '../../lib/icons';
import MainSlide from '../../components/Slides/Main/MainSlide';
import { Helmet } from 'react-helmet';
import { BeatLoader } from "react-spinners";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    // Scroll to top first
    window.scrollTo(0, 0);

    // Delay to allow layout to stabilize before ending loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Adjust time if needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const mediaElements = Array.from(document.querySelectorAll("img, video"));
    let loadedCount = 0;

    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount === mediaElements.length) {
        setIsLoading(false);
      }
    };

    if (mediaElements.length === 0) {
      setIsLoading(false);
    } else {
      mediaElements.forEach((el) => {
        if (el instanceof HTMLImageElement && el.complete) {
          checkAllLoaded();
        } else if (el instanceof HTMLVideoElement && el.readyState >= 3) { // HAVE_FUTURE_DATA
          checkAllLoaded();
        } else {
          el.addEventListener("load", checkAllLoaded);
          el.addEventListener("error", checkAllLoaded);
        }
      });
    }

    return () => {
      mediaElements.forEach((el) => {
        el.removeEventListener("load", checkAllLoaded);
        el.removeEventListener("error", checkAllLoaded);
      });
    };
  }, []);


  const statisticsSlideRef = useRef<HTMLDivElement>(null);
  const weMachineSlideRef = useRef<HTMLDivElement>(null);
  const ourCommitmentSlideRef = useRef<HTMLDivElement>(null);
  const refs = [weMachineSlideRef, ourCommitmentSlideRef];

  useEffect(() => {
    document.documentElement.setAttribute('color-scheme', 'dark');
  })

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden'; // Disable scrolling
    } else {
      document.body.style.overflow = 'auto'; // Re-enable scrolling
    }

    return () => {
      document.body.style.overflow = 'auto'; // Ensure scroll is reset on unmount
    };
  }, [isLoading]);


  if (isLoading) {
    return (
      <div className="loading-screen">
        <BeatLoader
          color={"var(--accent-1--dark)"}
          loading={isLoading}
          // cssOverride={override}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Billet Precision Ltd. | High Precision Machine Shop in Ottawa, Ontario</title>
        <meta name="description" content="High Precision Machine Shop in Ottawa, Ontario. CNC machining experts for aerospace, defense, and more." />
        <meta property="og:title" content="Billet Precision Ltd. | High Precision Machine Shop in Ottawa, Ontario" />
        <meta property="og:description" content="High Precision Machine Shop in Ottawa, Ontario. CNC machining experts for aerospace, defense, and more." />
        <link rel="canonical" href="https://billetprecision.ca" />
      </Helmet>

      <div className="main-content" id="home-main-content">
        <MainSlide />
        <StatisticsSlide ref={statisticsSlideRef} />
        {/* <WeMachineSlide ref={weMachineSlideRef} /> */}
        <WeMachineSlide2 ref={weMachineSlideRef} />
        <MissionVisionValuesSlide />
        <OurCommitmentSlide ref={ourCommitmentSlideRef} />
        {/* <Customers /> */}
        <Certifications />
      </div>

    </>
  );
};

export default Home;
